import { defineLevel } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   MONDE 3 · NIVEAU 1 — LE FLANC.

     0:00  intro          6 s
     0:06  bloc F1       28 s   le flanc — l'Égide, qu'on ne tue pas de face
     0:34  respiration    4 s
     0:38  bloc F2       32 s   le démontage — le Bastion, répétition du boss
     1:10  respiration    4 s

   Premier niveau du monde 3 (Le Cœur du Secteur), sans boss. Le monde apprend à
   DÉCIDER : l'Égide demande si l'angle vaut le détour, le Bastion quelle pièce
   vaut la dépense.

   ⚠️ Blocs 0 → 4 de l'ancien `monde-3`, re-basés (offset 0).
   ═══════════════════════════════════════════════════════════════════════════ */

export default defineLevel({
  id: 'monde-3-1',
  duration: 74,
  blocks: [
    { at: 0, wave: 'intro' },
    // Champ d'entrée du Cœur du Secteur : quelques rochers pour rappeler que le
    // terrain est solide ici aussi, décalés hors de la ligne de tir.
    {
      at: 6,
      wave: 'f1-flanc',
      obstacles: [
        { at: 3, obstacle: 'astero-eclat', x: -190 },
        { at: 8, obstacle: 'astero-bloc', x: 225 },
        { at: 13, obstacle: 'astero-eclat', x: -245 },
      ],
    },
    { at: 34, wave: 'respiration' },
    // COMPLEXE MILITAIRE — sa place naturelle : le bloc « démontage » enseigne
    // déjà quelle pièce d'un porteur vaut la dépense (le Bastion). Le caisson est
    // indestructible ; ce qu'on démonte, ce sont ses deux sentinelles (Mortiers
    // ancrés). Posé franchement à gauche pour fermer une voie sans jamais couper
    // le tir central.
    {
      at: 38,
      wave: 'f2-demontage',
      obstacles: [
        {
          at: 4,
          obstacle: 'complexe-caisson',
          x: -205,
          sentinels: [
            { enemy: 'mortier', offX: -40, offY: 22 },
            { enemy: 'mortier', offX: 40, offY: 22 },
          ],
        },
        { at: 12, obstacle: 'astero-noyau', x: 235 },
      ],
    },
    { at: 70, wave: 'respiration' },
  ],
});
